(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zo-warranty"]) return;
  try {
    
  // Native disclosure controls work without JavaScript. Section links also open
  // their destination so keyboard and mobile navigation reveal the requested text.
  function revealWarrantyTopic() {
    const target = document.getElementById(window.location.hash.slice(1));
    if (target && target.matches('.zo-warranty__detail')) target.open = true;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.zo-warranty a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target && target.matches('.zo-warranty__detail')) target.open = true;
  });
  window.addEventListener('hashchange', revealWarrantyTopic);
  revealWarrantyTopic();

  } catch(e) { console.error(e); }
})();
})();
